import React, { useState, useEffect } from 'react'
import axios from 'axios'

import Caixa from '../TermoVisita/ModulosCrefito/Caixa'
import Cabecalho from '../CabecalhoView/Cabecalho'

const CertidaoRotaFechada = () => {
    const [dados, setDados] = useState()
    const [data, setData] = useState()
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        const id = window.location.pathname.slice(21)
        axios(`/api/rotaNaoRealizada/getById/${id}`)
            .then(resp => {
                setDados(resp.data)
                if (resp.data.data) {
                    const dia = resp.data.data.slice(8,10)
                    const mes = resp.data.data.slice(5,7)
                    const ano = resp.data.data.slice(0,4)
                    const data = dia + "/" + mes + "/" + ano
                    setData(data)
                } else setData("")
                setLoaded(true)
            })
            .catch(error => alert(error))
    }, [])
    return (
        <>
            {RenderCertidao()}
        </>
    )

    function RenderCertidao() {
        if (loaded) {
            return (
                <>
                    <Caixa>
                        <Cabecalho estado={dados.estado} />
                        <h2 style={{marginTop: "5vh", fontSize: "25px"}}>Certidão</h2>
                        <div className="paragrafo">
                            &nbsp;&nbsp;&nbsp;&nbsp;Certifico para os devidos fins de comprovação que em {data} me dirigi
                            ao estabelecimento {dados.estabelecimento}, situado no endereço {dados.endereco},&nbsp;
                            deixando de realizar o ato fiscalizatório em razão do mesmo encontrar-se {dados.situacao}.
                        </div>
                        {dados.url && (
                            <img src={dados.url} alt="imagem" />
                        )}
                        <div className="identificacao mt-5">
                            <p>{dados.user}</p>
                            <p>Fiscal Técnico</p>
                        </div>
                    </Caixa>
                </>
            )
        }
    }
}

export default CertidaoRotaFechada